if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then()
    .catch(function (error) {
      console.log("Ошибка при регистрации service worker-а:", error);
    });
}
